import React, { useState, useEffect } from 'react';
import Dropdown from '../Dropdown';
import SelectNooco from '../Select';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
// import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
// import Input from '../Input';
import { SelectProps } from '../Select';
import { DropdownProps } from '../Dropdown';
// import {NoocoList} from "./Lists"
// import { RE2020List } from './Lists';
// import { EPCMList } from "./Lists"
import { AllotmentNodeDTO } from '../../models/AllotmentNodeDTO';
import { sortFilterSousLot, useDebounce } from '../../functions';
import unorm from 'unorm';
import Tooltip from '@material-ui/core/Tooltip';
import { DisplayMode } from '../Select/Select';
import { ALLOTMENT_IDS, REFERENCE_TYPE_NAME } from '../../globalVariable/enumType';
import InfoIcon from '@material-ui/icons/Info';

interface Option {
  label: string;
  value: string;
  bgColor?: string;
  color: string;
  border: string;
  icon?: React.ReactNode;
  title: string;
}

enum SelectedOptionValues {
  EQUIPEMENTS = 'equipements',
  ENSEMBLES = 'ensembles',
  PRODUITS = 'produitsmodélisés',
  INIES = 'INIES',
  EAU = 'eau',
  ENERGIE = 'energie',
  FICHESCONFIG = 'fichesconfig',
  DECHETS = 'déchets',
}

interface certifiedAllotmentsDTO {
  RE2020: AllotmentNodeDTO[];
  EPCM: AllotmentNodeDTO[];
}

interface searchBarOptionsFilteredDTO {
  energie: AllotmentNodeDTO[];
  eau: AllotmentNodeDTO[];
  inies: AllotmentNodeDTO[];
  ensembles: AllotmentNodeDTO[];
  equipements: AllotmentNodeDTO[];
}

interface SearchGroupProps {
  selectProps1: SelectProps;
  dropdownProps: DropdownProps;
  selectProps2: SelectProps;
  dropdownColor: string;
  marginRight: string;
  triggerBreadcrumb: () => void;
  ListType: ('Nooco' | 'RE2020' | 'EPCM')[];
  defaultValue?: Option;
  findParentNode: Function;
  allAllotments: AllotmentNodeDTO[];
  certifiedAllotments: certifiedAllotmentsDTO;
  api: any;
  bundleOptions: {
    AllotmentNodes: [];
    UnitId: number;
    id: number;
    name: string;
    type_fiche: 'bundle';
  }[];
  gridStyle: string;
  isBundleScreen?: boolean;
  searchBarOptionsFiltered: searchBarOptionsFilteredDTO;
  t: Function;
}

const SearchGroup: React.FC<SearchGroupProps> = ({
  selectProps1,
  dropdownProps,
  selectProps2,
  dropdownColor,
  marginRight = '10px',
  isBundleScreen = false,
  certifiedAllotments,
  triggerBreadcrumb,
  findParentNode,
  allAllotments,
  api,
  bundleOptions,
  gridStyle,
  searchBarOptionsFiltered,
  t,
  projectTypeId,
}) => {
  const options: Option[] = [
    {
      title: t('APP.NOOCO_UI.SEARCHGROUP.EQUIPMENTS', {
        defaultValue: 'Equipements',
      }),
      label: 'Equipements',
      value: 'equipements',
      bgColor: '#789ADE',
      color: 'white',
      border: 'none',
    },
    {
      title: t('APP.NOOCO_UI.SEARCHGROUP.BUNDLE', {
        defaultValue: 'Ensembles',
      }),
      label: 'Ensembles',
      value: 'ensembles',
      bgColor: '#465292',
      color: 'white',
      border: 'none',
    },
    {
      title: t('APP.NOOCO_UI.SEARCHGROUP.MODELED_PRODUCT', {
        defaultValue: 'Produits modélisés',
      }),
      label: 'Produits modélisés',
      value: 'produitsmodélisés',
      bgColor: '#22A899',
      color: 'white',
      border: 'none',
    },
    {
      title: t('APP.NOOCO_UI.SEARCHGROUP.INIES', { defaultValue: 'INIES' }),
      label: 'INIES',
      value: 'INIES',
      color: 'white',
      border: 'none',
      bgColor: '#789ADE',
    },
    {
      title: t('APP.NOOCO_UI.SEARCHGROUP.WATER', { defaultValue: 'Eau' }),
      label: 'Eau',
      value: 'eau',
      bgColor: '#26AAFE',
      color: 'white',
      border: 'none',
    },
    {
      title: t('APP.NOOCO_UI.SEARCHGROUP.ENERGY', { defaultValue: 'Energie' }),
      label: 'Energie',
      value: 'energie',
      bgColor: '#E1C357',
      color: 'white',
      border: 'none',
    },
    {
      title: t('APP.NOOCO_UI.SEARCHGROUP.CONFIG_SHEET', {
        defaultValue: 'Fiches Configurées',
      }),
      label: 'Fiches Configurées',
      value: 'fichesconfig',
      bgColor: '#DEAF78',
      color: 'white',
      border: 'none',
    },
    {
      title: t('APP.NOOCO_UI.SEARCHGROUP.GARBAGE', { defaultValue: 'Déchets' }),
      label: 'Déchets',
      value: 'déchets',
      bgColor: 'grey',
      color: 'white',
      border: 'none',
    },
    {
      title: t('APP.NOOCO_UI.SEARCHGROUP.TRANSPORTS', {
        defaultValue: 'Transports',
      }),
      label: 'Transports',
      value: 'transports',
      bgColor: '#965e5c',
      color: 'white',
      border: 'none',
    },
  ];

  const [selectedValue, setSelectedValue] = useState(null);
  let selectedOptionSendByApp =
    typeof selectProps1.value === 'string'
      ? selectProps1.value || selectProps1.defaultValue
      : selectProps1.value?.value || selectProps1.defaultValugst;

  const [selectedOption, setSelectedOption] = useState<Option>(
    selectedOptionSendByApp
      ? options.find(
          (option) =>
            option.label?.toLowerCase() === selectedOptionSendByApp?.toLowerCase() ||
            option.value?.toLowerCase() === selectedOptionSendByApp?.toLowerCase()
        )
      : options[0]
  );
  const [iniesOptions, setIniesOptions] = useState([]);
  const [loadingInies, setLoadingInies] = useState(false);
  const [inputChange, setInputChange] = useState('');
  const debouncedInputChange = useDebounce(inputChange, 700);

  const returnTitleForIniesSheet = (iniesSheet) => {
    return (
      <div className="alignVerticalBlocks">
        <span>{iniesSheet.processedLabel}</span>
        {iniesSheet.isReference && (
          <Tooltip
            placement="top"
            title={t('APP.NOOCO-UI.TOOLTIP.REFERENCE_PRODUCT', {
              defaultValue: 'Produit de référence de la gamme',
            })}
          >
            <InfoIcon
              className="hoverBlue"
              style={{ color: '#a0aed3', marginLeft: '10px' }}
            />
          </Tooltip>
        )}
      </div>
    );
  };

  useEffect(() => {
    if (debouncedInputChange.length >= 1) {
      setLoadingInies(true);
      api
        .getSheetByIniesId(debouncedInputChange, projectTypeId)
        .then((response) => {
          if (response.status === 202) {
            alert(response.data.message);
          }

          setIniesOptions(
            Array.isArray(response.data)
              ? response.data.map((iniesSheet) => ({
                  ...iniesSheet,
                  label: iniesSheet.processedLabel,
                  value: iniesSheet.id,
                  title: iniesSheet.isReference
                    ? returnTitleForIniesSheet(iniesSheet)
                    : iniesSheet.processedLabel,
                }))
              : []
          );
          setLoadingInies(false);
        })
        .catch(() => {});
    }
  }, [debouncedInputChange]);

  const getOptions = (type) => {
    let keyToFind =
      selectedOption.value !== SelectedOptionValues.EAU &&
      selectedOption.value !== SelectedOptionValues.ENERGIE
        ? SelectedOptionValues.EQUIPEMENTS
        : selectedOption.value;
    switch (type) {
      case REFERENCE_TYPE_NAME.RE2020:
        return certifiedAllotments.RE2020[keyToFind];
      case 'EPCM':
      case REFERENCE_TYPE_NAME.EPCM:
        return certifiedAllotments.EPCM[keyToFind];
      default:
        return [];
    }
  };

  const placeholderMap = {
    equipements: 'Rechercher un équipement',
    inies: 'Rechercher une fiche INIES par son ID ou nom',
    ensembles: 'Rechercher un ensemble',
    products: 'Rechercher un produit sur mesure',
    fichesconfig: 'Rechercher un équipement',
    water: "Rechercher un usage d'eau",
    energy: "Rechercher un usage d'énergie",
    dechets: 'Rechercher un déchet',
    transports: 'Rechercher un transport',
  };

  const modifiedDropdownProps = {
    ...dropdownProps,
    placeholder:
      placeholderMap[selectedOption.value.toLowerCase()] ||
      dropdownProps.placeholder,
    value: dropdownProps.value || selectedValue,
    onChange: (value) => {
      if (
        [
          SelectedOptionValues.INIES,
          SelectedOptionValues.ENSEMBLES,
          SelectedOptionValues.FICHESCONFIG,
          SelectedOptionValues.PRODUITS,
        ].includes(selectedOption.value)
      ) {
        if (value === selectedOption.value) {
          dropdownProps.onChange(value);
          return;
        }
        let selectedOptionsAvailables = [
          SelectedOptionValues.FICHESCONFIG,
          SelectedOptionValues.PRODUITS,
          SelectedOptionValues.ENSEMBLES,
        ];
        let arrayToFind =
          selectedOption.value === 'INIES'
            ? iniesOptions
            : selectedOptionsAvailables.includes(selectedOption.value)
            ? searchBarOptionsFiltered[selectedOption.value]
            : bundleOptions;
        const objToFind = arrayToFind.find((obj) => obj.id === value);
        setSelectedValue(value);
        dropdownProps.onChange(objToFind);
      } else {
        if (value !== 'Recherche Avancée') {
          dropdownProps.onChange(value);
          setSelectedValue(value);
        } else {
          triggerBreadcrumb();
          setSelectedValue(null);
        }
      }
    },
    options: [
      ...(selectedOption.value === 'equipements'
        ? [
            {
              title: (
                <div style={{ display: 'flex' }}>
                  <MoreHorizIcon style={{ alignSelf: 'center' }} />
                  <span>Recherche Avancée</span>
                </div>
              ),
              titleString: 'Recherche Avancée',
              value: 'Recherche Avancée',
              key: 'AdvancedSearch',
            },
          ]
        : []),
      ...(searchBarOptionsFiltered[selectedOption.value.toLowerCase()] || []),
    ],
    filterTreeNode: (inputValue, treeNode) => {
      const label = treeNode.name;
      const normalizedInput = unorm.nfd(inputValue).replace(/[\u0300-\u036f]/g, '');
      const normalizedLabel = unorm.nfd(label).replace(/[\u0300-\u036f]/g, '');

      return (
        (String(treeNode.id_inies) &&
          String(treeNode.id_inies).includes(inputValue.toLowerCase())) ||
        (treeNode.name &&
          normalizedLabel.toLowerCase().indexOf(normalizedInput.toLowerCase()) >=
            0) ||
        treeNode.key === 'AdvancedSearch'
      );
    },
  };

  const hexToRGBA = (hex, alpha = 1) => {
    let [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
  };

  const filterValue =
    selectedOption.value === 'equipements'
      ? 'invert(56%) sepia(90%) saturate(344%) hue-rotate(188deg) brightness(92%) contrast(88%)'
      : selectedOption.value === 'INIES'
      ? 'invert(42%) sepia(80%) saturate(285%) hue-rotate(156deg) brightness(95%) contrast(98%)'
      : '';
  const menuItemHoverColor =
    selectedOption.value === 'equipements'
      ? hexToRGBA('#789ADE', 0.2)
      : selectedOption.value === 'INIES'
      ? hexToRGBA('#4183A5', 0.2)
      : 'null';

  const renderSearchInput = () => {
    if (selectedOption.value === 'INIES') {
      return (
        <Dropdown
          value={inputChange}
          key={dropdownProps.value || dropdownProps.defaultValue}
          onSearch={(value) => {
            setInputChange(value);
          }}
          defaultValue={dropdownProps.defaultValue}
          loading={loadingInies}
          style={{
            color: dropdownColor,
            width: '100%',
            flexGrow: '1',
          }}
          {...modifiedDropdownProps}
          options={iniesOptions || []}
          selectedOption={selectedOption}
          dropdownBorder="black"
          filterTreeNode={(inputValue, treeNode) => {
            const nameToLowerCase = treeNode.name.toLowerCase();
            const brandNameToLowerCase = treeNode.brand?.toLowerCase();
            const idInies = treeNode.id_inies;

            return (
              nameToLowerCase.includes(inputValue) ||
              brandNameToLowerCase?.includes(inputValue) ||
              idInies === inputValue
            );
          }}
        />
      );
    } else {
      return (
        <Dropdown
          value={dropdownProps.value}
          key={dropdownProps.value || dropdownProps.defaultValue}
          defaultValue={dropdownProps.defaultValue}
          onChange={() => {}}
          style={{
            color: dropdownColor,
            width: '100%',
            flexGrow: '1',
          }}
          {...modifiedDropdownProps}
          dropdownBorder="black"
          selectedOption={selectedOption}
        />
      );
    }
  };

  return (
    <div
      style={{
        display: 'grid',
        'grid-template-columns': gridStyle || '[first] 21%[line2] 48% [line3] 29%',
        columnGap: '10px',
        width: '100%',
      }}
    >
      <SelectNooco
        disabled={selectProps1.disabled}
        defaultValue={selectProps1.defaultValue || options[0].value}
        value={selectedOption}
        arrowColor={'white'}
        style={{
          background:
            selectedOption.label === 'INIES'
              ? 'transparent'
              : selectedOption.bgColor,
          backgroundSize: 'auto',
          backgroundImage:
            selectedOption.label === 'INIES'
              ? 'linear-gradient(to right, #6CB99D, #4183A5)'
              : undefined,
          height: '32px',
          border: `1px solid ${selectedOption.border}`,
          fontFamily: 'DM Sans Regular',
          marginRight,
          color: selectedOption.color,
          paddingRight: '20px',
          ...selectProps1.style,
        }}
        menuItemStyle={{
          fontSize: '9.5px',
          fontFamily: 'DM Sans Regular',
        }}
        onChange={(value: string) => {
          setSelectedOption(
            options.find((option) => option.value === value) || options[0]
          );
          setInputChange('');
          setSelectedValue(null);
          selectProps1.onChange(
            options.find((option) => option.value === value) || options[0]
          );
        }}
        itemsArray={
          selectProps1.filterOptions
            ? options.filter(
                (option) =>
                  selectProps1.filterOptions.includes(option.label.toLowerCase()) ||
                  selectProps1.filterOptions.includes(option.value)
              )
            : options
        }
        keyItem="value"
        keyDisplay="title"
        icon={
          <div
            style={{
              textAlign: 'center',
              fontSize: '9.5px',
              width: '100%',
              whiteSpace: 'nowrap',
            }}
          ></div>
        }
      />

      {renderSearchInput()}
      <div className="allotment-attachment" key={selectProps2.noocoOptions}>
        {![
          SelectedOptionValues.ENSEMBLES,
          SelectedOptionValues.PRODUITS,
          SelectedOptionValues.FICHESCONFIG,
        ].includes(selectedOption.value) &&
          ((selectProps2.noocoOptions && selectProps2.noocoOptions.length > 0) ||
            (selectProps2.value && selectProps2.value.length > 0)) &&
          selectProps2.ListType.map((type) => {
            let currentAllotmentId =
              type === 'Nooco'
                ? ALLOTMENT_IDS.NOOCO
                : type === 'EPCM' || type === REFERENCE_TYPE_NAME.EPCM
                ? ALLOTMENT_IDS.EPCM
                : ALLOTMENT_IDS.RE2020;
            let currentNode = selectProps2.value.find(
              (node) => node && node.AllotmentId === currentAllotmentId
            );

            return (
              <Tooltip
                title={
                  currentNode
                    ? type === 'Nooco'
                      ? findParentNode(currentNode, allAllotments, [], [])[0].name
                      : currentNode.name
                    : undefined
                }
              >
                <span>
                  <SelectNooco
                    displayMode={
                      type === 'Nooco'
                        ? DisplayMode.IconOnly
                        : type === REFERENCE_TYPE_NAME.RE2020 ||
                          type === 'EPCM' ||
                          type === REFERENCE_TYPE_NAME.EPCM
                        ? DisplayMode.CertifiedMode
                        : null
                    }
                    key={selectedOption || selectProps2.value}
                    value={
                      !currentNode
                        ? null
                        : type === 'Nooco'
                        ? findParentNode(currentNode, allAllotments, [], [])[0]
                        : currentNode
                    }
                    onChange={(selectedOptionValue) => {
                      selectProps2.onChange(selectedOptionValue, type);
                    }}
                    arrowColor="white"
                    disabled={selectProps2.disabled}
                    itemsArray={
                      type === 'Nooco'
                        ? sortFilterSousLot(selectProps2.noocoOptions)
                        : getOptions(type)
                    } // Passer sur un state
                    keyItem={'name'}
                    keyDisplay="name"
                    filterValue={filterValue}
                    menuItemHoverColor={menuItemHoverColor}
                    style={{
                      background:
                        currentNode && currentNode.color
                          ? currentNode.color
                          : hexToRGBA(selectedOption.bgColor, 0.7), // 0.5 is the opacity
                      height: '32px',
                      width: '55px',
                      padding: '10px',
                      fontFamily: 'DM Sans Regular',
                      fontSize: '11.5px',
                      lineHeight: '50px',
                      color: 'white',
                    }}
                    menuItemStyle={{
                      fontSize: '9.5px',
                      fontFamily: 'DM Sans Regular',
                      background: 'white',
                      margin: '3px',
                      borderRadius: '5px',
                    }}
                  />
                </span>
              </Tooltip>
            );
          })}
      </div>
    </div>
  );
};

export default SearchGroup;
